import { Box, Typography } from '@mui/material';
import { getActivityDetail } from './activityHelpers';

const DetailLabel = ({ children }) => (
    <Typography component="span" sx={{ display: 'inline', fontWeight: 400, color: 'rgba(255,255,255,0.75)', mr: 0.5 }}>
        {children}
    </Typography>
);

const DetailValue = ({ children }) => (
    <Typography component="span" sx={{ display: 'inline', fontWeight: 700, color: '#fff', mr: 2 }}>
        {children}
    </Typography>
);

const InlineFields = ({ fields }) => (
    <Box sx={{ lineHeight: 1.8 }}>
        {fields.map(({ label, value }) => (
            <Box key={label} component="span" sx={{ mr: 1.5, whiteSpace: 'nowrap' }}>
                <DetailLabel>{label}</DetailLabel>
                <DetailValue>{value}</DetailValue>
            </Box>
        ))}
    </Box>
);

const NewOldRows = ({ newFields, oldFields }) => (
    <Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1.5, lineHeight: 1.8 }}>
            <Typography sx={{ color: '#95F205', fontWeight: 700, minWidth: 36, flexShrink: 0 }}>
                New
            </Typography>
            <Box sx={{ flex: 1 }}>
                <InlineFields fields={newFields} />
            </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, lineHeight: 1.8 }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontWeight: 700, minWidth: 36, flexShrink: 0 }}>
                Old
            </Typography>
            <Box sx={{ flex: 1 }}>
                <InlineFields fields={oldFields} />
            </Box>
        </Box>
    </Box>
);

const ActivityDetailPanel = ({ activity }) => {
    const detail = getActivityDetail(activity);

    if (detail.mode === 'minimal') {
        return (
            <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 13 }}>
                No additional portfolio details recorded for this event.
            </Typography>
        );
    }

    return (
        <Box sx={{ bgcolor: 'primary.dark', borderRadius: 2, p: { xs: 1.5, md: 2 } }}>
            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 14, mb: 1.5 }}>
                {detail.title}
            </Typography>

            {detail.mode === 'inline' && <InlineFields fields={detail.fields} />}
            {detail.mode === 'newOld' && (
                <NewOldRows newFields={detail.newFields} oldFields={detail.oldFields} />
            )}
        </Box>
    );
};

export default ActivityDetailPanel;
